<template>
    <div class="change-pwd">
        <a-form-model
            layout="horizontal"
            ref="form"
            :model="form"
            :rules="rules"
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }"
        >
            <a-form-model-item label="用户名">
                <a-input v-model="userInfo.userName" disabled> </a-input>
            </a-form-model-item>
            <a-form-model-item label="旧密码" prop="oldPassword">
                <a-input v-model="form.oldPassword" type="password" placeholder="请输入旧密码"> </a-input>
            </a-form-model-item>
            <a-form-model-item label="新密码" prop="newRawPassword">
                <a-input v-model="form.newRawPassword" type="password" placeholder="请输入密码"> </a-input>
            </a-form-model-item>
            <a-form-model-item label="确认密码" prop="confirmPassword">
                <a-input v-model="form.confirmPassword" type="password" placeholder="请再次输入密码"> </a-input>
            </a-form-model-item>
        </a-form-model>

        <div class="btns">
            <div class="btn" @click="cancel">取消</div>
            <div class="btn save" @click="save">保存</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RsaEncryptUtils from '@/common/rsaEncryptUtils';
import { validatePass } from '@/common/utils';
import { changePwd } from '../../../common/api';

export default {
    computed: {
        ...mapGetters(['userInfo'])
    },

    data() {
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('确认密码不能为空'));
            } else if (value !== this.form.newRawPassword) {
                return callback(new Error('两次输入密码不一致!'));
            }
            return callback();
        };

        return {
            form: {
                oldPassword: '',
                confirmPassword: '',
                newRawPassword: ''
            },
            rules: {
                oldPassword: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
                newRawPassword: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirmPassword: [{ validator: validatePass2, trigger: 'blur' }]
            }
        };
    },
    methods: {
        cancel() {
            this.$refs.form.resetFields();
        },

        save() {
            this.$refs.form.validate(async valid => {
                if (!valid) return false;
                const publicKey = sessionStorage.getItem('rsa-public-key');
                const params = {
                    oldPassword: RsaEncryptUtils.encode(publicKey, this.form.oldPassword),
                    newRawPassword: RsaEncryptUtils.encode(publicKey, this.form.newRawPassword)
                };
                await changePwd(this.userInfo.id, params).then(() => {
                    this.$message.success('修改密码成功');
                    this.$refs.form.resetFields();
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.change-pwd {
    height: 648px;
    .btns {
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
        .btn {
            border: 1px solid rgba(217, 217, 217, 1);
            border-radius: 2px;
            width: 60px;
            height: 32px;
            margin-right: 16px;
            font-size: 14px;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }

        .save {
            background: #005299;
            color: #fff;
        }
    }
}
</style>
